var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackInstaLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vertical container",
    clipPath: "url(#clip0_14_7013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1228 3.33961C14.1169 3.39457 15.049 3.8402 15.7159 4.57939C16.3828 5.31859 16.7306 6.29142 16.6834 7.2859C16.6834 9.60921 14.6777 11.0363 12.753 12.7478C10.8532 14.4441 9.82994 15.3713 9.49869 15.5854C9.13794 15.3517 7.87797 14.2067 6.2444 12.7478C4.31133 11.0295 2.31399 9.58879 2.31399 7.2859C2.26677 6.29142 2.61453 5.31859 3.28147 4.57939C3.94842 3.8402 4.88049 3.39457 5.87457 3.33961C6.42526 3.32292 6.97085 3.44941 7.45801 3.70672C7.94518 3.96402 8.35724 4.34333 8.65392 4.80756C9.2892 5.6962 9.39508 6.14089 9.50096 6.14089C9.60684 6.14089 9.7112 5.6962 10.3404 4.80529C10.6354 4.33891 11.0476 3.9581 11.5359 3.7009C12.0241 3.4437 12.5713 3.31913 13.1228 3.33961ZM13.1228 1.82705C12.436 1.80506 11.7532 1.93828 11.125 2.2168C10.4969 2.49531 9.9397 2.91194 9.49491 3.43566C9.05049 2.91347 8.49443 2.4978 7.8678 2.21937C7.24116 1.94094 6.55998 1.80686 5.87457 1.82705C4.47913 1.88161 3.16207 2.48651 2.21139 3.50947C1.26071 4.53243 0.753769 5.89021 0.801419 7.2859C0.801419 10.0161 2.72994 11.6928 4.59418 13.3135C4.80821 13.4995 5.02451 13.6871 5.23929 13.8784L6.016 14.5727C6.86307 15.3787 7.75111 16.1406 8.67661 16.8552C8.92148 17.0137 9.20697 17.0981 9.49869 17.0981C9.7904 17.0981 10.0759 17.0137 10.3208 16.8552C11.2757 16.1187 12.1911 15.3324 13.0631 14.4993L13.7603 13.8762C13.9819 13.6795 14.2066 13.4837 14.4297 13.2908C16.1948 11.7593 18.196 10.0237 18.196 7.2859C18.2436 5.89021 17.7367 4.53243 16.786 3.50947C15.8353 2.48651 14.5182 1.88161 13.1228 1.82705Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_7013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1508,
    height: 18.1508,
    fill: "white",
    transform: "translate(0.42334 0.386963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackInstaLike);
export default __webpack_public_path__ + "static/media/black-insta-like.e6739b0490a62e120c7d713595214e65.svg";
export { ForwardRef as ReactComponent };